import React, { useEffect, useState } from 'react';

/**
 * JujuGorselKiyas: JujuMood toplantısı için benzer global takı markalarının ana sayfa ve ürün görseli kıyası (6 Eki 2026).
 * Route: /r/juju-gorsel-kiyas (sidebar YOK, tam ekran slayt).
 * Yeniden üretmek için: node src/pages/juju-gorsel-kiyas/build.js (PDF dahil)
 *
 * 🔴 iframe'e sandbox EKLEME, PDF indirme kırılır.
 * HTML modülü ~73KB, ana bundle'da işi yok: dinamik import ile yükleniyor.
 */
export default function JujuGorselKiyas() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('./jujuGorselKiyasHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#1d1d1f">Sunum yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  // Yükleme zemini sunumun kendi zemini (--deck) ile aynı, açılışta flaş olmasın.
  if (!html) return <div style={{ ...fill, background: '#F0F0F2' }} />;

  return (
    <iframe
      title="JujuMood · Benzer Markalar"
      srcDoc={html}
      style={fill}
    />
  );
}
